module.exports = __webpack_public_path__ + "static/media/bible.11c69193.png";